// extracted by mini-css-extract-plugin
export default {"container":"Sl-z","bubbleNav":"Tl-z","graphic":"Ul-z","contact":"Vl-z"};